import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-o-monitor-de-secas',
  templateUrl: './o-monitor-de-secas.component.html',
  styleUrls: ['./o-monitor-de-secas.component.css']
})
export class OMonitorDeSecasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
